export const getUsers = state => state.users.users;
export const getCurrentUser = state => state.users.currentUser;
